


export default {
    inheritAttrs: false,

    data: function () {
        return {
            totalCharacter: 0,
            displayError: true,
            isExpanded: false
        }
    },
    props: {
        id: {
            type: String,
            default() {
                return `textarea-input-${this._uid}`
            },
        },
        value: String,
        minCharacters: 0,
        maxCharacters: 0,
        label: String,
        placeholder: '',
        displayCount: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        focus() {
            this.$refs.input.focus();

        },
        select() {
            this.$refs.input.select()
        },
        charCount: function () {
            this.totalCharacter = this.$refs.input.value.length;
            this.displayError = false;
        },
        resize: function () {
            this.isExpanded = true;
        }
    },
    // watch: {
    //     error: function(newError, oldError) { // watch it
    //         this.displayError = true;
    //     }
    // }
}
